import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { selectRecentActivity } from 'broker/selectors/account'


function renderRow(item, idx) {
  return <div className="RecentActivity__item" key={idx}>
    <div className="RecentActivity__value"><i className="fa fa-circle-o" /><a onClick={() => {}}>{item.agent_name}</a> was referred a client</div>
    <div className="RecentActivity__subvalue">{ item.time_since }</div>
  </div>
}

const RecentActivity = ({recent_activity}) => {
  const activityList = recent_activity ?
    <div className="RecentActivity__outer">
      <div className="RecentActivity__inner">
      { recent_activity.map(renderRow) }
      </div>
    </div> :
    null

  return <div className="RecentActivity -panel -panel--no-bottom">
    { activityList }
  </div>
}

export default connect(createStructuredSelector({ recent_activity: selectRecentActivity }))(RecentActivity)
